import React from "react";
import Homepage from "./containers/Homepage";
import Project from "./containers/ProjectPage";
import News from "./containers/NewsPage";
import AboutUs from "./containers/AboutUs";
import SharedList from "./containers/SharedList";
import Contact from "./containers/Contact";
import Search from './containers/searchPage';

export const routes = [
  {
    id: 1,
    path: "/",
    exact: true,
    main: ({ history, match }) => <Homepage history={history} />,
    name: "Trang chủ"
  },
  {
    id: 2,
    path: "/du-an",
    exact: true,
    main: ({ history, match }) => <Project history={history} match={match} />,
    name: "Dự án",
    cateParentName: "project"
  },
  {
    id: 3,
    path: "/tin-tuc",
    exact: true,
    main: ({ history, match }) => <News history={history} match={match} />,
    name: "Tin tức",
    cateParentName: "news"
  },
  {
    id: 4,
    path: "/about-us",
    exact: false,
    main: ({ history, match }) => <AboutUs history={history} match={match} />,
    name: "Về chúng tôi"
  },
  {
    id: 5,
    path: "/shared",
    exact: false,
    main: ({ history, match }) => <SharedList history={history} match={match}/>,
    name: "Chia sẻ"
  },
  {
    id: 6,
    path: "/contact",
    exact: false,
    main: () => <Contact />,
    name: "Liên hệ"
  },

  {
    id: 7,
    path: "/search",
    exact: false,
    main: ({ history, match }) => <Search history={history} match={match} />,
    name: ""
  }
];
